export default "__VITE_ASSET__34f157e3__"